<script>

export default{
    name: "BaseTag"
}
</script>

<template>
    <div class="balance-tag">
        <span><slot>text</slot></span>
    </div>
</template>

<style scoped lang="scss">
.balance-tag {
    /* Badge */

    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 2px 8px;

    /* Brand/50 */
    background: #F9F5FF;
    /* Brand/200 */
    border: 1px solid #E9D7FE;
    border-radius: 16px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;

    span {
        /* Text */

        /* Text-xs/Medium */
        font-family: Geist, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        /* identical to box height, or 133% */
        text-align: center;

        /* Brand/700 */
        color: #6941C6;

        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-grow: 0;

    }
}
</style>
